import { supabase } from "../lib/supabase";

function rowToDestination(row) {
  if (!row) return null;
  return {
    id: row.id,
    sort_order: row.sort_order,
    title: {
      hr: row.title_hr,
      en: row.title_en,
      de: row.title_de,
      es: row.title_es,
    },
    text: {
      hr: row.text_hr,
      en: row.text_en,
      de: row.text_de,
      es: row.text_es,
    },
    image_class: row.image_class,
    image: row.image || "",
  };
}

function destinationToRow(d) {
  return {
    sort_order: d.sort_order ?? 0,
    title_hr: d.title?.hr ?? "",
    title_en: d.title?.en ?? "",
    title_de: d.title?.de ?? "",
    title_es: d.title?.es ?? "",
    text_hr: d.text?.hr ?? "",
    text_en: d.text?.en ?? "",
    text_de: d.text?.de ?? "",
    text_es: d.text?.es ?? "",
    image_class: d.image_class || "dest-1",
    image: d.image ?? "",
  };
}

export async function fetchDestinations() {
  const { data, error } = await supabase
    .from("destinations")
    .select("*")
    .order("sort_order", { ascending: true });

  if (error) {
    console.error("Supabase fetchDestinations error:", error);
    return null;
  }
  return (data || []).map(rowToDestination);
}

export async function createDestination(destination) {
  const row = destinationToRow(destination);
  const { data, error } = await supabase.from("destinations").insert(row).select("id").single();
  if (error) {
    console.error("Supabase createDestination error:", error);
    return { error };
  }
  return { data: { ...destination, id: data.id } };
}

export async function updateDestination(destination) {
  const { id, ...rest } = destination;
  const row = destinationToRow(rest);
  const { error } = await supabase.from("destinations").update(row).eq("id", id);
  if (error) {
    console.error("Supabase updateDestination error:", error);
    return { error };
  }
  return {};
}

export async function deleteDestination(id) {
  const { error } = await supabase.from("destinations").delete().eq("id", id);
  if (error) {
    console.error("Supabase deleteDestination error:", error);
    return { error };
  }
  return {};
}
